import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <React.Fragment>
      <div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
        <div className="container-fluid">
          <div className="text-dark text-center">
            <span className="text-muted fw-bold me-1">
              {currentYear} © Copyright All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default Footer;
